import { COLORS } from '@/shared/lib';
import { ArrowDownIcon, Typography } from '@/shared/ui';
import { CurrencyIcon } from './currency-icon';

interface CurrencySelectTriggerProps {
  name: string;
  code: string;
}
export const CurrencySelectTrigger = ({
  name,
  code,
}: CurrencySelectTriggerProps) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex min-w-[55px] items-center gap-1">
        <ArrowDownIcon
          className="h-5 w-5"
          color={COLORS['icon-base-500']}
          isActive={false}
        />
        <Typography variant="16-r">{code}</Typography>
      </div>
      <CurrencyIcon ticker={code} size="lg" />
    </div>
  );
};
